module.exports = __webpack_public_path__ + "static/fonts/materialdesignicons-webfont.9bfeb985.ttf";